import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import IconButton from '@/components/IconButton';
import { MenuIcon } from '@/icons';
import { classes, getSidebarClass } from './utils';

export type TileShellProps = {
  compact?: boolean;
  hasActiveFile: boolean;
  isSidebarOpen: boolean;
  sidebarWide?: boolean;
  sidebar: ReactNode;
  children?: ReactNode;
  onShowSidebar: () => void;
};

export default function TileShell({
  compact = false,
  hasActiveFile,
  isSidebarOpen,
  sidebarWide = false,
  sidebar,
  children,
  onShowSidebar,
}: TileShellProps) {
  return (
    <div
      data-compact={compact || undefined}
      className={twMerge(classes.wrapper, compact && classes.tileFrame)}>
      <div
        className={getSidebarClass(
          hasActiveFile,
          compact,
          isSidebarOpen,
          sidebarWide
        )}>
        {sidebar}
      </div>
      {hasActiveFile && !isSidebarOpen && (
        <div className={classes.sidebarStrip}>
          <IconButton
            title="Show files"
            titlePosition="right"
            onClick={() => onShowSidebar()}>
            <MenuIcon className={classes.menuIconClosed} />
          </IconButton>
        </div>
      )}
      {children}
    </div>
  );
}
